var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "log-property-form row q-pa-xs q-col-gutter-sm" },
    [
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("species-selector", {
            attrs: {
              "preselected-species": _vm.editedLogProps.species,
              error: _vm.errors.species,
              "error-message": _vm.$t("error.logProps.species"),
              emit: "",
              dense: ""
            },
            on: {
              input: function($event) {
                return _vm.$emit("update", _vm.editedLogProps)
              }
            },
            model: {
              value: _vm.editedLogProps.species,
              callback: function($$v) {
                _vm.$set(_vm.editedLogProps, "species", $$v)
              },
              expression: "editedLogProps.species"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: {
              label: _vm.$t("logNo"),
              error: _vm.errors.name,
              "error-message": _vm.$t("error.logProps.name")
            },
            on: {
              input: function($event) {
                return _vm.$emit("update", _vm.editedLogProps)
              }
            },
            model: {
              value: _vm.editedLogProps.name,
              callback: function($$v) {
                _vm.$set(_vm.editedLogProps, "name", $$v)
              },
              expression: "editedLogProps.name"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: { label: _vm.$t("quality") },
            on: {
              input: function($event) {
                return _vm.$emit("update", _vm.editedLogProps)
              }
            },
            model: {
              value: _vm.editedLogProps.customerQualityName,
              callback: function($$v) {
                _vm.$set(_vm.editedLogProps, "customerQualityName", $$v)
              },
              expression: "editedLogProps.customerQualityName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: { label: _vm.$t("structure") },
            on: {
              input: function($event) {
                return _vm.$emit("update", _vm.editedLogProps)
              }
            },
            model: {
              value: _vm.editedLogProps.structure,
              callback: function($$v) {
                _vm.$set(_vm.editedLogProps, "structure", $$v)
              },
              expression: "editedLogProps.structure"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: { label: _vm.$t("characteristic") },
            on: {
              input: function($event) {
                return _vm.$emit("update", _vm.editedLogProps)
              }
            },
            model: {
              value: _vm.editedLogProps.characteristic,
              callback: function($$v) {
                _vm.$set(_vm.editedLogProps, "characteristic", $$v)
              },
              expression: "editedLogProps.characteristic"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: { label: _vm.$t("grade") },
            on: {
              input: function($event) {
                return _vm.$emit("update", _vm.editedLogProps)
              }
            },
            model: {
              value: _vm.editedLogProps.grade,
              callback: function($$v) {
                _vm.$set(_vm.editedLogProps, "grade", $$v)
              },
              expression: "editedLogProps.grade"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: { label: _vm.$t("place") },
            on: {
              input: function($event) {
                return _vm.$emit("update", _vm.editedLogProps)
              }
            },
            model: {
              value: _vm.editedLogProps.place,
              callback: function($$v) {
                _vm.$set(_vm.editedLogProps, "place", $$v)
              },
              expression: "editedLogProps.place"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: { label: _vm.$t("thickness") },
            on: {
              input: function($event) {
                return _vm.$emit("update", _vm.editedLogProps)
              }
            },
            model: {
              value: _vm.editedLogProps.thicknessMm,
              callback: function($$v) {
                _vm.$set(_vm.editedLogProps, "thicknessMm", $$v)
              },
              expression: "editedLogProps.thicknessMm"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: { label: _vm.$t("internalQuality") },
            on: {
              input: function($event) {
                return _vm.$emit("update", _vm.editedLogProps)
              }
            },
            model: {
              value: _vm.editedLogProps.internalQualityName,
              callback: function($$v) {
                _vm.$set(_vm.editedLogProps, "internalQualityName", $$v)
              },
              expression: "editedLogProps.internalQualityName"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "col-12 col-sm-6" },
        [
          _c("q-input", {
            attrs: { label: _vm.$t("logInfo") },
            on: {
              input: function($event) {
                return _vm.$emit("update", _vm.editedLogProps)
              }
            },
            model: {
              value: _vm.editedLogProps.logInfo,
              callback: function($$v) {
                _vm.$set(_vm.editedLogProps, "logInfo", $$v)
              },
              expression: "editedLogProps.logInfo"
            }
          })
        ],
        1
      ),
      _vm._v(" "),
      _vm.showSubmit
        ? _c(
            "div",
            { staticClass: "q-mt-md", staticStyle: { "max-width": "600px" } },
            [
              _c("q-btn", {
                attrs: { label: _vm.$t("button.cancel"), flat: "" },
                on: {
                  click: function($event) {
                    return _vm.$emit("close")
                  }
                }
              }),
              _vm._v(" "),
              _c("q-btn", {
                attrs: {
                  label: _vm.$t("button.create"),
                  loading: _vm.loading,
                  color: "primary"
                },
                on: {
                  click: function($event) {
                    return _vm.$emit("update-log")
                  }
                }
              })
            ],
            1
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }